import { getGroupingIdConfig } from "src/decisionsOverview/groupingIdConfig";

export const getDefaultMetadataMapping = () => [
  {
    db_field: null,
    flow_input_field: getGroupingIdConfig().responseField,
  },
  {
    db_field: null,
    flow_input_field: "version",
  },
];

export const DELETED_VERSION_NAME = "Deleted version";
